/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($, undefined) {


    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function() {


                var $body,
                    $main,
                    $site,
                    smoothState,
                    $projectsGrid;


                $body = $('body');
                $main = $('#main');
                $site = $('html, body');

                var stateTransitions = {};


                smoothState = $main.smoothState({
                    // Runs when a link has been activated
                    duration: 250,
                    loadingClass: 'page-loading',
                    cacheLength: 2,
                    debug: true,
                    prefetch: true,
                    scroll: false,
                    blacklist: '.js--no-smoothState, .js--no-smoothState a',
                    onBefore: function($anchor, $container) {
                        if ($('.body').hasClass('home')) {

                            var scroll = $('.banner').offset().top;
                            console.log(scroll);
                            $site.animate({
                                scrollTop: scroll
                            }, 250, function() {

                            });

                        }

                        smoothState.transitions = {};
                        smoothState.transitions.mode = 'fade';

                        $main.attr('data-transition', smoothState.transitions.mode);

                        console.log($main.data('transition'));
                    },
                    onStart: {
                        duration: 650, // Duration of our animation
                        render: function($container) {
                            console.log('hey');


                            $container.addClass('page-transition-out');
                            smoothState.restartCSSAnimations();

                        }

                    },
                    onReady: {
                        duration: 0,
                        render: function($container, $newContent) {

                            $container.removeClass('page-transition-out');
                            $container.html($newContent);

                            if ($('.body').hasClass('home')) {
                                var scroll = $('.banner').offset().top;
                                console.log(scroll);
                                $site.animate({
                                    scrollTop: scroll
                                }, 0, function() {});
                            }

                            initIsotope();
                            var sticky = new Waypoint.Sticky({
                                element: $('header.banner')[0]
                            })

                        }
                    },
                    onAfter: function($container, $newContent) {
                        s.refresh();
                    }
                }).data('smoothState');

                // catch Gardens click
                $('.menu-item.js--no-smoothState, .js--menu-logo').click(function(e) {
                    e.preventDefault();
                    if ($('.body').hasClass('home')) {
                        var scroll = $('.banner').offset().top;
                        console.log(scroll);
                        $site.animate({
                            scrollTop: scroll
                        }, 250, function() {

                        });
                    } else {
                        if (!$(this).hasClass('js--menu-contact')) {
                            smoothState.load('/');
                        }
                    }
                })
                var initHomeSlider = function() {
                    if ($(".body").hasClass('home')) {
                        $('.js--main-gallery').flickity({
                            imagesLoaded: true,
                            setGallerySize: false,
                            wrapAround: true,
                            autoPlay: 6000,
                            pauseAutoPlayOnHover: false
                        });
                    }
                    var $gallery = $('.js--main-gallery').flickity();

                    $gallery.on('settle click cellSelect', function() {
                        $('.js--hp-carousel__number__index').html($gallery.data('flickity').selectedIndex + 1);
                        $('.js--hp-carousel__number__total').html($gallery.data('flickity').cells.length);
                    })

                }
                var $grid;
                var initIsotope = function() {
                    if ($('.feed-wrapper').length) {
                        $grid = $('.row--isotope').isotope({
                            // options
                            itemSelector: '.feed-content',
                            layoutMode: 'fitRows'
                        });

                        $grid.on('arrangeComplete', function(event, filteredItems) {
                            if ($(window).innerWidth() > 960) {

                                s.refresh();
                            }
                        });

                        $grid.imagesLoaded().progress(function() {
                            $grid.isotope('layout');
                        });


                        $('.js--feed-link').click(function(e) {
                            e.preventDefault();
                            $('.js--feed-link.active').removeClass('active');
                            $(this).addClass('active');
                            var category = $(this).data('filter');
                            //$('.feed-wrapper').fadeOut(function() {
                            //  $('.feed-wrapper').css('opacity', '1').css('visibility', 'hidden');
                            $('.row--isotope').isotope({
                                filter: category,
                                hiddenStyle: {
                                    opacity: 0
                                },
                                visibleStyle: {
                                    opacity: 1
                                }
                            });

                            //});
                            //$('.feed-wrapper').css('visibility', 'visible').fadeIn();
                            if ($('.feed-mobile-link').hasClass('active')) {
                                $('.js--feed-mobile-link').html($(this).html());
                                $('.js--feed--menu').stop(true, true).slideUp();
                                $site.animate({
                                    scrollTop: 0
                                }, 250);
                                $('.feed-mobile-link').removeClass('active');
                            }


                        });



                    }
                }
                initIsotope();
                initHomeSlider();

                var resizeTimer;

                $(window).on('resize', function(e) {

                    clearTimeout(resizeTimer);
                    resizeTimer = setTimeout(function() {

                        //$grid.isotope('layout');
                        if ($(window).innerWidth() < 960) {
                            s.destroy();

                        }

                    }, 250);

                });

                $('.js--hp-carousel__nav-prev').click(function(e) {
                    e.preventDefault();
                    var $gallery = $('.js--main-gallery').flickity();
                    $gallery.data('flickity').player.pause();
                    $gallery.flickity('previous');
                    $('.js--hp-carousel__number__index').html($gallery.data('flickity').selectedIndex + 1);

                })

                $('.js--hp-carousel__nav-next').click(function(e) {
                    e.preventDefault();
                    var $gallery = $('.js--main-gallery').flickity();
                    $gallery.data('flickity').player.pause();
                    $gallery.flickity('next');
                    $('.js--hp-carousel__number__index').html($gallery.data('flickity').selectedIndex + 1);
                })
                if (($(window).innerWidth() > 960) && (!(Modernizr.touchevents))) {

                    var s = skrollr.init({
                        forceHeight: false,
                        smoothScrolling: false
                    });
                }

                var sticky = new Waypoint.Sticky({
                    element: $('header.banner')[0]
                })

                $('.js--feed-mobile-link').click(function(e) {
                    e.preventDefault();
                    if ($(this).parents('.feed-mobile-link').hasClass('active')) {
                        $('.js--feed--menu').stop(true, true).slideUp();
                        $('.feed-mobile-link').removeClass('active');
                    } else {
                        $('.js--feed--menu').stop(true, true).slideDown();
                        $('.feed-mobile-link').addClass('active');
                    }
                })
                if ($(window).innerWidth() < 960) {

                    $('.js--garden-gallery').flickity({
                        imagesLoaded: true,
                        setGallerySize: false,
                        wrapAround: true,
                        lazyLoad: true,
                        arrowShape: {
                            x0: 10,
                            x1: 50,
                            y1: 50,
                            x2: 60,
                            y2: 50,
                            x3: 20
                        }
                    });
                }
                $('.js--garden-link').click(function(e) {
                    e.preventDefault();
                    if ($(window).innerWidth() < 960) {
                        var gallery = $(this).data('gallery');

                        var $gardenGallery = $('.js--garden-gallery', $(this));

                        jQuery.ajax({
                            type: "POST",
                            url: '/wp-admin/admin-ajax.php',
                            data: {
                                'action': 'get_gallery',
                                'gallery': gallery
                            },
                            dataType: 'html'
                        })
                            .done(function(response) {
                                var $elements = $(response);

                            })


                    } else {
                        $('.main-gallery--home').removeClass('main-gallery--home');
                        $("html, body").animate({
                            scrollTop: 0
                        }, "slow");

                        var title = $(this).find('h2').html();
                        var subtitle = $(this).find('.garden-content--content').html();
                        var gallery = $(this).data('gallery');


                        var $gallery = $('.js--main-gallery').flickity();

                        $('.js--main-gallery').fadeOut(function() {
                            $gallery.css('visibility', 'hidden');
                            $gallery.flickity('remove', $('.js--main-gallery .gallery-cell'));

                            jQuery.ajax({
                                type: "POST",
                                url: '/wp-admin/admin-ajax.php',
                                data: {
                                    'action': 'get_gallery',
                                    'gallery': gallery
                                },
                                dataType: 'html'
                            })
                                .done(function(response) {
                                    var $elements = $(response);

                                    $gallery.flickity('prepend', $elements).flickity('select', 0, true, true).show().flickity('resize');

                                    $gallery.on('settle click', function() {
                                        $('.js--hp-carousel__number__index').html($gallery.data('flickity').selectedIndex + 1);
                                        $('.js--hp-carousel__number__total').html($gallery.data('flickity').cells.length);
                                    })

                                    $('.js--hp-carousel__title').html(title);
                                    $('.js--hp-carousel__subtitle').html(subtitle);


                                    $gallery.css({
                                        opacity: 0.0,
                                        visibility: "visible"
                                    }).animate({
                                        opacity: 1.0
                                    });

                                })

                        });
                    }

                })

                $('.js--menu-contact a').click(function(e) {
                    e.preventDefault();
                    $('.contact-modal').fadeIn();
                })
                $('.js--menu-contact-close').click(function(e) {
                    e.preventDefault();
                    $('.contact-modal').fadeOut();
                });
            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function() {



            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'cw_feed': {
            init: function() {


            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.